<template>
  <div>
    <div class="p-option-bar-container row">
      <div class="p-option-bar-button-group">
        <button
          type="button"
          v-for="(option, idx) in optionsComp"
          :key="idx"
          :class="giveMeClass(option.value)"
          class="p-option-bar-button-group-item capitalize-first"
          @click="clickOption(option.value)"
        >
          {{ option.text }}
        </button>
      </div>
    </div>
    <div>
      <slot name="header"></slot>
      <div v-for="(option, idx) in optionsComp" :key="idx + 'slot'">
        <div v-if="option.value === valueLocal">
          <slot :name="option.value"></slot>
        </div>
      </div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IOptionBarItem } from "@/components/look";

@Component
export class POptionBarNew extends Vue {
  @Prop({ required: true }) value!: string;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.valueLocal = this.value;
  }
  @Prop({ required: true }) options!: IOptionBarItem[];

  valueLocal = "";

  get optionsComp(): IOptionBarItem[] {
    return this.options.filter((option) => !option.hidden);
  }

  giveMeClass(value: string): string {
    if (value === this.valueLocal) {
      return "active";
    } else {
      return "";
    }
  }
  clickOption(value: string): void {
    this.$emit("input", value);
    this.$emit("change", value);
  }
}
export default POptionBarNew;
</script>
<style lang="scss" scoped>
.p-option-bar-button-group-item {
  min-width: 5rem;
  height: 2.4rem;
  border: solid 1px #e8e8e8;
  background-color: var(--blanco-prosegur);
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  color: var(--secundario-prosegur-oscuro);
  padding-left: 2rem;
  padding-right: 2rem;

  @media (max-width: 767px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  &:first-of-type {
    border-top-left-radius: 2rem;
    border-bottom-left-radius: 2rem;

    @media (max-width: 767px) {
      padding-left: 1.5rem;
    }
  }

  &:last-of-type {
    border-top-right-radius: 2rem;
    border-bottom-right-radius: 2rem;
    padding-right: 2.5rem;

    @media (max-width: 767px) {
      padding-right: 1.5rem;
    }
  }

  &:hover {
    border: solid 1px var(--amarillo-prosegur);
  }

  &.active {
    border: solid 1px var(--amarillo-prosegur) !important;
    background-color: var(--amarillo-prosegur) !important;
    font-weight: bold;
  }
}

.p-option-bar-container {
  justify-content: center;
  padding: 1rem;
}

.capitalize-first::first-letter {
  text-transform: uppercase;
}
</style>
